import { useState } from "react"

import { Analytics } from "@/App/Analytics"
import { LiveRates } from "@/App/LiveRates"
import { FxTrades } from "@/App/Trades"
import {
  BottomNavigation,
  BottomNavigationTab,
} from "@/components/BottomNavigation"

type FxMobileTab = "liverates" | "trades" | "analytics"

const FX_TABS: BottomNavigationTab[] = [
  { key: "liverates", icon: "eye", label: "Live Rates" },
  { key: "trades", icon: "frame", label: "Trades" },
  { key: "analytics", icon: "trend", label: "Analytics" },
]

export const MobileFxPage = () => {
  const [activeTab, setActiveTab] = useState<FxMobileTab>("liverates")

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="flex-1 overflow-auto">
        {activeTab === "liverates" && <LiveRates />}
        {activeTab === "trades" && <FxTrades />}
        {activeTab === "analytics" && <Analytics />}
      </div>
      <BottomNavigation
        tabs={FX_TABS}
        activeTab={activeTab}
        onTabChange={(key) => setActiveTab(key as FxMobileTab)}
      />
    </div>
  )
}
